import patients from '../../api/patients'
import i18n from "../../i18n";

// initial state
const state = {
    all: [],
    tegnerScore: {
        score_question_answer: null,
        score_question_text: ''
    },
    selectedPatient: {
        gender: '',
        lastname: '',
        firstname: '',
        email: '',
        phone: '',
        address: '',
        opale_number: '',
        declined_study: null,
        decline_data_collection: null,
        birth_date: null,
        notification: null
    },
    form: {
        gender: '',
        firstname: '',
        lastname: '',
        email: '',
        no_email: false,
        phone: '',
        birth_date: null,
        opale_number: '',
        declined_study: false,
        decline_data_collection: false,
        intervention_date: null,
        treatment_type: '',
        treatment_subtype: '',
        diagnostic_type: ''
    },
    contactForm: {
        email: '',
        no_email: false,
        phone: '',
        address: '',
        postcode: '',
        city: '',
        country: 'Suisse',
        notification: true
    },
    doctorsForm: {
        mainName: '', // not reactive on the object main
        physioName: '', // not reactive on the object main
        main: {
            id: null,
        },
        no_doctor: false,
        physio: {
            id: null
        },
        no_physio: false,
        others: [{
            id: null,
            pivot: {
                type: 'OTHER',
                label: null
            }
        }]
    },
    firmForm: {
        firm_select: '',
        firm_select_other: '',
    },
    jobForm: {
        job: '',
    },
    tegnerForm: {
        tegner: null,
    },
    tegnerUrl: '',
    addressUrl: '',
    studyUrl: '',
    doctorUrl: '',
    firmUrl: '',
    jobUrl: '',
}

// getters
const getters = {
}

// actions
const actions = {
    getAllPatients ({ commit, rootState }) {
        patients.getPatients(rootState.axios).then(result => {
            commit('setPatients', result.data.patients)
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.GET_ALL_PATIENTS_LOADING_ERROR'), content: reason
            }, { root: true })
        })
    },
    createPatient({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            patients.add(state.form, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: i18n.t('success.CREATE_PATIENT_SUCCESS.title'), content: i18n.t('success.CREATE_PATIENT_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.CREATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },
    quickCreatePatient({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            patients.quickCreate(state.form, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: i18n.t('success.CREATE_PATIENT_SUCCESS.title'), content: i18n.t('success.CREATE_PATIENT_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.CREATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },
    updatePatient({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            patients.update(state.selectedPatient.id, state.form, rootState.axios).then(result => {
                commit('setSelectedPatient', result.data.patient)
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_SUCCESS.content')
                }, { root: true })

                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },
    postDeletePatient({ state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            patients.delete(state.selectedPatient.id, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_SUCCESS.content')
                }, { root: true })

                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },
    getPatientInfo({ state, commit, rootState }) {
        patients.get(state.selectedPatient.id, rootState.axios).then(result => {
            commit('setSelectedPatient', result.data.patient)
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.GET_PATIENT_LOADING_ERROR'), content: reason
            }, { root: true })

        })
    },
    getTegner({ commit, rootState }) {
        patients.getTegner(rootState.axios).then(result => {
            commit('setTegner', result.data.tegner)
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.GET_TEGNER_LOADING_ERROR'), content: reason
            }, { root: true })

        })
    },
    loadPatientForm({ state, commit, rootState }) {
        patients.get(state.selectedPatient.id, rootState.axios).then(result => {
            commit('initPatientForms', result.data.patient)
        }).catch(reason => {
            commit('notifications/showError', {
                title: i18n.t('errors.GET_PATIENT_LOADING_ERROR'), content: reason
            }, { root: true })

        })
    },
    updateContactInfos({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            patients.updateContactInfos(state.selectedPatient.id, state.contactForm, rootState.axios).then(result => {
                commit('setSelectedPatient', result.data.patient)
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_CONTACT_INFOS_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_CONTACT_INFOS_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_CONTACT_INFOS_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },
    updateDoctorsInfos({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            patients.updateDoctorsInfos(state.selectedPatient.id, state.doctorsForm, rootState.axios).then(result => {
                commit('setSelectedPatient', result.data.patient)
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_DOCTORS_INFOS_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_DOCTORS_INFOS_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_DOCTORS_INFOS_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },
    updateFirmInfos({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            patients.updateFirmInfos(state.selectedPatient.id, state.firmForm, rootState.axios).then(result => {
                commit('setSelectedPatient', result.data.patient)
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },
    updateJobInfos({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            patients.updateJobInfos(state.selectedPatient.id, state.jobForm, rootState.axios).then(result => {
                commit('setSelectedPatient', result.data.patient)
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },
    updateTegnerInfos({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            patients.updateTegnerInfos(state.selectedPatient.id, state.tegnerForm, rootState.axios).then(result => {
                commit('setSelectedPatient', result.data.patient)
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },
    updateTegnerInfosFromNotification({ state, commit, rootState }) {

        return new Promise((resolve, reject) => {
            patients.updateTegnerInfosFromNotification(state.tegnerUrl, state.tegnerForm, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    updateAddressInfosFromNotification({ state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            patients.updateAddressInfosFromNotification(state.addressUrl, state.contactForm, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    updateDoctorInfosFromNotification({ state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            patients.updateDoctorInfosFromNotification(state.doctorUrl, state.doctorsForm, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    updateStudyInfosFromNotification({ state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            patients.updateStudyInfosFromNotification(state.studyUrl, state.form, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    updateFirmInfosFromNotification({ state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            patients.updateFirmInfosFromNotification(state.firmUrl, state.firmForm, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    },

    updateJobInfosFromNotification({ state, commit, rootState }) {
        return new Promise((resolve, reject) => {
            patients.updateJobInfosFromNotification(state.jobUrl, state.jobForm, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: i18n.t('success.UPDATE_PATIENT_SUCCESS.title'), content: i18n.t('success.UPDATE_PATIENT_SUCCESS.content')
                }, { root: true })
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: i18n.t('errors.UPDATE_PATIENT_ERROR'), content: reason
                }, { root: true })
                reject(reason)
            })
        });
    }
}

// mutations
const mutations = {
    setPatients (state, patients) {
        state.all = patients
    },
    setTegner (state, value) {
      state.tegnerScore = value
    },
    setTegnerUrl (state, value) {
      state.tegnerUrl = value
    },
    setFormGender (state, value) {
        state.form.gender = value
    },
    setFormOpaleNumber (state, value) {
        state.form.opale_number = value
    },
    setFormDeclinedStudy (state, value) {
        state.form.declined_study = value
    },
    setFormDeclineDataCollection (state, value) {
        state.form.decline_data_collection = value
    },
    setFormBirthDate (state, value) {
        state.form.birth_date = value
    },
    setFormFirstname (state, value) {
        state.form.firstname = value
    },
    setFormLastname (state, value) {
        state.form.lastname = value
    },
    setFormQuickEmail (state, value) {
        state.form.email = value
    },
    setFormNoQuickEmail (state, value) {
        state.form.no_email = value
    },
    setFormQuickPhone (state, value) {
        state.form.phone = value
    },
    setFormEmail (state, value) {
        state.contactForm.email = value
    },
    setFormNoEmail (state, value) {
        state.contactForm.no_email = value
    },
    setFormPhone (state, value) {
        state.contactForm.phone = value
    },
    setFormAddress (state, value) {
        state.contactForm.address = value
    },
    setFormPostcode (state, value) {
        state.contactForm.postcode = value
    },
    setFormCity (state, value) {
        state.contactForm.city = value
    },
    setFormCountry (state, value) {
        state.contactForm.country = value
    },
    setFormNotification (state, value) {
        state.contactForm.notification = value
    },
    setFormMainDoctorId (state, value) {
        state.doctorsForm.main.id = value
    },
    setFormMainDoctorName (state, value) {
        state.doctorsForm.mainName = value
    },
    setFormPhysioName (state, value) {
        state.doctorsForm.physioName = value
    },
    setFormNoDoctor (state, value) {
        state.doctorsForm.no_doctor = value
        state.doctorsForm.main.id = null
    },
    setFormPhysioId (state, value) {
        state.doctorsForm.physio.id = value
    },
    setFormNoPhysio (state, value) {
        state.doctorsForm.no_physio = value
        state.doctorsForm.physio.id = null
    },
    setFormOtherDoctorType (state, {index, data}) {
        state.doctorsForm.others[index].pivot.type = data
    },
    setOtherDoctors (state, value) {
        state.doctorsForm.others = value
    },
    setFormOtherDoctorId (state, {index, data}) {
        state.doctorsForm.others[index].id = data
    },
    setFormOtherDoctorLabel (state, {index, data}) {
        state.doctorsForm.others[index].pivot.label = data
    },
    addNewEmptyDoctor (state) {
        state.doctorsForm.others.push({id: null, pivot: { type: "OTHER", label: null }})
    },
    setFormSelectFirm (state, value) {
        state.firmForm.firm_select = value
    },
    setFormSelectFirmOther (state, value) {
        state.firmForm.firm_select_other = value
    },
    setFormJob (state, value) {
        state.jobForm.job = value
    },
    setFormTegner (state, value) {
        state.tegnerForm.tegner = value
    },
    removeDoctorAtIndex (state, indexToRemove) {
        state.doctorsForm.others.splice(indexToRemove, 1)
    },
    setSelectedPatient(state, value) {
        state.selectedPatient = value
    },
    setSelectedPatientId(state, value) {
        state.selectedPatient.id = value
    },
    setFormTreatmentType(state, value) {
        state.form.treatment_type = value
    },
    setFormTreatmentSubType(state, value) {
        state.form.treatment_subtype = value
    },
    setFormDiagnosticType(state, value) {
        state.form.diagnostic_type = value
    },
    setFormInterventionDate(state, value) {
        state.form.intervention_date = value
    },
    setAddressUrl(state, value) {
        state.addressUrl = value
    },
    setStudyUrl(state, value) {
        state.studyUrl = value
    },
    setDoctorUrl(state, value) {
        state.doctorUrl = value
    },
    setFirmUrl(state, value) {
        state.firmUrl = value
    },
    setJobUrl(state, value) {
        state.jobUrl = value
    },
    initPatientForms(state, data) {
        state.form.gender = data.gender
        state.form.opale_number = data.opale_number
        state.form.firstname = data.firstname
        state.form.lastname = data.lastname
        state.form.birth_date = data.birth_date
        state.form.declined_study = data.declined_study
        state.form.decline_data_collection = data.decline_data_collection
        state.form.email = data.email
        state.form.no_email = data.no_email
        state.form.phone = data.phone
        state.contactForm.email = data.email
        state.contactForm.no_email = data.no_email
        state.contactForm.phone = data.phone
        state.contactForm.address = data.address
        state.contactForm.city = data.city
        state.contactForm.country = data.country
        state.contactForm.postcode = data.postcode
        state.contactForm.notification = data.notification
        state.doctorsForm.main = data.main_doctor ? data.main_doctor : {'id' : null}
        state.doctorsForm.no_doctor = data.no_doctor
        state.doctorsForm.physio = data.physio_doctor ? data.physio_doctor : {'id' : null}
        state.doctorsForm.no_physio = data.no_physio
        state.doctorsForm.others = data.other_doctors.length > 0 ? data.other_doctors : [{'id' : null, pivot: {'type': "OTHER"}}]
        state.firmForm.firm_select = data.firm_select
        state.firmForm.firm_select_other = data.firm_select_other
        state.jobForm.job = data.job
        state.tegnerForm.tegner = data.tegner
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
